import React, { useEffect } from 'react';
import { Spinner } from '@acorns/web-components';
import { StyledModal, StyledTextInput, StyledPrivateInput, StyledButton, StyledTitle } from '../components';
import { LOGIN_FLOW_STATES } from '../types';
import { Type, write } from '../../../utils/auth';
import { useLoginForm, LOGIN_FORM_STATE } from './useLoginForm'; // Ensuring user credential handler is requireed

var LoginForm = function LoginForm(_ref) {
  var onClose = _ref.onClose,
      onStateChange = _ref.onStateChange,
      onUserCreds = _ref.onUserCreds,
      show = _ref.show,
      userCreds = _ref.userCreds;

  var _useLoginForm = useLoginForm(userCreds || {
    email: '',
    password: ''
  }),
      errors = _useLoginForm.errors,
      data = _useLoginForm.data,
      handleChange = _useLoginForm.handleChange,
      handleSubmit = _useLoginForm.handleSubmit,
      loading = _useLoginForm.loading,
      result = _useLoginForm.result,
      values = _useLoginForm.values; // State management


  useEffect(function () {
    if (LOGIN_FORM_STATE.success === result) {
      onStateChange(LOGIN_FLOW_STATES.closed);
    } else if (LOGIN_FORM_STATE.requiresChallenge === result) {
      onUserCreds({
        email: values.email,
        password: values.password,
        challengeId: data.id
      });
      onStateChange(LOGIN_FLOW_STATES.challenge);
    } else if (LOGIN_FORM_STATE.failure === result) {
      onUserCreds(values || {
        email: '',
        password: ''
      });
      onStateChange(LOGIN_FLOW_STATES.error);
    } else {
      onStateChange(LOGIN_FLOW_STATES.login);
    }
  }, [result]);
  /**
   * Write token to localhost cookie whenever we get data back.
   */

  useEffect(function () {
    if ((data === null || data === void 0 ? void 0 : data.__typename) === 'AuthSession') {
      write(Type.token, data.token);
    }
  }, [data]);
  return /*#__PURE__*/React.createElement(StyledModal, {
    onRequestClose: onClose,
    isOpen: show,
    isTrapModal: true,
    accessibilityProperties: {
      labelledBy: 'login-modal-title'
    }
  }, /*#__PURE__*/React.createElement(StyledTitle, {
    id: "login-form-title"
  }, "Developer Login"), /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(StyledTextInput, {
    autoFocus: true // eslint-disable-line
    ,
    error: !!errors.email,
    errorText: errors.email,
    id: "email",
    name: "email",
    label: "Email",
    onChange: handleChange,
    type: "text",
    value: values.email
  }), /*#__PURE__*/React.createElement(StyledPrivateInput, {
    error: !!errors.password,
    errorText: errors.password,
    id: "password",
    name: "password",
    label: "Password",
    onChange: handleChange,
    type: "password",
    value: values.password
  }), /*#__PURE__*/React.createElement(StyledButton, {
    buttonType: "submit",
    onPress: handleSubmit
  }, loading ? /*#__PURE__*/React.createElement(Spinner, {
    height: 25,
    width: 25
  }) : 'Login'), /*#__PURE__*/React.createElement(StyledButton, {
    secondary: true,
    onPress: onClose
  }, "Cancel")));
};

export { LoginForm };